import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalConfigKey, StorageKey } from 'src/app/shared/constants/global-config.constant';
import { getHttpRetryOperator } from 'src/app/shared/utils/http-retry.util';
import { environment } from 'src/environments/environment';
import { CommonService } from '../common/common.service';

@Injectable({
  providedIn: 'root'
})
export class DataPocketService {

  constructor(
    private httpClient: HttpClient,
    private commonService: CommonService
  ) { }

  getPocketbaseHeader(): HttpHeaders {
    const headers = new HttpHeaders({
      'Authorization': `${localStorage.getItem(StorageKey.POCKET_TOKEN)}`,
      'Content-Type': 'application/json',
    })
    return headers;
  }

  async loginPocketbase() {
    const result = await this.httpClient.post<any>(
      `${environment.pocket_endpoint}/api/collections/co_app_users/auth-with-password`,
      {
        identity: environment.pocket_acc,
        password: localStorage.getItem(StorageKey.POCKET_KEY)
      }
    ).pipe(
      getHttpRetryOperator({
        delayMs: 3000,
        skipRetryOnStatusCodes: [400, 401, 403, 404],
        onRetry: (current, max) => this.commonService.showRetryToast(current, max)
      })
    ).toPromise();
    console.log(result);
    localStorage.setItem(StorageKey.POCKET_TOKEN, result.token);
    return result;
  }

  getTransactionIdByChargeId(charge_id: string) {
    return this.httpClient.get<any>(
      `${environment.pocket_endpoint}/api/collections/${environment.pocket_group}/records?filter=(charge_id='${charge_id}')`,
      { headers: this.getPocketbaseHeader() }
    ).pipe(
      getHttpRetryOperator({
        delayMs: 3000,
        skipRetryOnStatusCodes: [400, 401, 403, 404],
        onRetry: (current, max) => this.commonService.showRetryToast(current, max)
      })
    );
  }

  getTransactionIdByLinkId(link_id: string) {
    return this.httpClient.get<any>(
      `${environment.pocket_endpoint}/api/collections/${environment.pocket_group}/records?filter=(link_id='${link_id}')`,
      { headers: this.getPocketbaseHeader() }
    ).pipe(
      getHttpRetryOperator({
        delayMs: 3000,
        skipRetryOnStatusCodes: [400, 401, 403, 404],
        onRetry: (current, max) => this.commonService.showRetryToast(current, max)
      })
    );
  }

  getPaymentByTrxId(trx_id: string) {
    return this.httpClient.get<any>(
      `${environment.pocket_endpoint}/api/collections/${environment.pocket_group}/records?filter=(id='${trx_id}')`,
      { headers: this.getPocketbaseHeader() }
    ).pipe(
      getHttpRetryOperator({
        skipRetryOnStatusCodes: [400, 401, 403, 404],
        onRetry: (current, max) => this.commonService.showRetryToast(current, max)
      })
    );
  }

  getGlobalConfig(key: string) {
    return this.httpClient.get<any>(
      `${environment.pocket_endpoint}/api/collections/${environment.pocket_global_config_group}/records?filter=(key='${key}')`,
      { headers: this.getPocketbaseHeader() }
    ).pipe(
      getHttpRetryOperator({
        skipRetryOnStatusCodes: [400, 401, 403, 404],
        onRetry: (current, max) => this.commonService.showRetryToast(current, max)
      })
    );
  }

  async initiateConfigFromPocketbase() {
    const configKeyArray = [
      GlobalConfigKey.USE_OMEGA_RANDOM,
      GlobalConfigKey.FREE_WHITELIST_BRANCH,
      GlobalConfigKey.USE_FACE_DETECTION,
      GlobalConfigKey.SCULPTURE_BRANCH_HIDE_PAY,
      GlobalConfigKey.SCULPTURE_BRANCH_SKIP_TERMS,
      GlobalConfigKey.USE_POINT_COLLECTION,
      GlobalConfigKey.SKIP_POINT_COLLECTION,
      GlobalConfigKey.SCULPTURE_HIDE_PROMO_BUTTON,
      GlobalConfigKey.BRANCH_THEME_MAP,
      GlobalConfigKey.SKIP_PAYMENT_SUCCESS_PAGE
    ];
    const configResult = await this.getGlobalConfigByArray(configKeyArray).toPromise();

    if (configResult) {
      configResult.items.forEach(item => {
        sessionStorage.setItem(item.key, JSON.stringify(item.value));
      });
    }

  }

  getGlobalConfigByArray(key: string[]) {
    // convert key array to filter string like (key='key1') %7C%7C (key='key2') %7C%7C (key='key3')
    let filterString = '';
    key.forEach((k, index) => {
      filterString += `(key='${k}')`;
      if (index < key.length - 1) {
        filterString += ' %7C%7C ';
      }
    });
    return this.httpClient.get<any>(
      `${environment.pocket_endpoint}/api/collections/${environment.pocket_global_config_group}/records?filter=${filterString}`,
      { headers: this.getPocketbaseHeader() }
    ).pipe(
      getHttpRetryOperator({
        skipRetryOnStatusCodes: [400, 401, 403, 404],
        onRetry: (current, max) => this.commonService.showRetryToast(current, max)
      })
    );
  }

}
